var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',{staticClass:"col-md-5 login-right"},[_c('CRow',{staticClass:"login-right__content"},[_c('CCol',{staticClass:"login-right__text"},[_c('h3',{staticClass:"login-right__title"},[_vm._v("DataMorph")]),_vm._v(" "+_vm._s(_vm.$t("auth.right"))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }